import { useMemo } from "react";
import type { Mood } from "../../../types/models";

export interface UseMoodAggregationReturn {
  moodCounts: Record<string, number>;
  totalMoods: number;
}

export function useMoodAggregation(moods: Mood[]): UseMoodAggregationReturn {
  const moodCounts = useMemo(() => {
    return moods.reduce(
      (acc: Record<string, number>, mood: Mood) => {
        const duration = parseInt(String(mood.duration)) || 1;
        acc[mood.mood] = (acc[mood.mood] || 0) + duration;
        return acc;
      },
      {} as Record<string, number>
    );
  }, [moods]);

  const totalMoods = useMemo((): number => {
    return Object.values(moodCounts).reduce(
      (sum: number, count: number) => sum + count,
      0
    );
  }, [moodCounts]);

  return {
    moodCounts,
    totalMoods,
  };
}
